export const noop = (..._args: any[]): any => {};

export const findByKey = <U extends Record<string, unknown>, K extends keyof U>(
  coll: U[],
  key: K,
  value: U[K]
): U | null => {
  if (!(coll && Array.isArray(coll))) {
    return null;
  }
  return coll.find((item) => item[key] === value) ?? null;
};
